import type { IconProps } from './icons/props.ts'
import { AlexMark } from './AlexMark.tsx'
import css from './AlexWordmark.module.css'

/**
 * Render the Alex wordmark.
 * @param props.size - mark and line-box height in px (default 24).
 * @param props.className - extra class for layout placement.
 * @returns the Alex mark and product name.
 */
export function AlexWordmark({ size = 24, className }: IconProps) {
  return (
    <span
      className={[css.root, className].filter(Boolean).join(' ')}
      style={{ height: size }}
      aria-hidden="true"
    >
      <AlexMark size={size} className={css.mark} />
      <span>Alex</span>
    </span>
  )
}
